import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminCrossFilledIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8 14.666A6.66 6.66 0 0 0 14.667 8 6.66 6.66 0 0 0 8 1.333 6.66 6.66 0 0 0 1.334 8 6.66 6.66 0 0 0 8 14.666Zm-3.333-9.06.94-.94L8 7.06l2.394-2.393.94.94L8.94 8l2.394 2.393-.94.94L8 8.94l-2.393 2.393-.94-.94L7.06 8 4.667 5.606Z" />
  </Icon>
);

export default memo(AdminCrossFilledIcon);
